import React from 'react';

import { ITextAreaProps, TextArea } from '@rbilabs/components-library';
import { FieldProps } from 'formik';

export const FormikTextArea = React.forwardRef<
  HTMLTextAreaElement,
  FieldProps<string, { [key: string]: string }> & ITextAreaProps
>(({ field, form, ...props }, forwardedRef) => {
  const { errors, touched } = form;

  const fieldTouched = touched?.[field.name];
  const errorMessage = errors?.[field.name];

  return (
    <TextArea
      {...field}
      errorMessage={fieldTouched && errorMessage ? errorMessage : undefined}
      {...props}
      ref={forwardedRef}
    />
  );
});
